import { BridgeToken, bridgeTokens } from '../constants/bridgeTokens';

export function isBigIntGreaterThanZero(value: BigInt): boolean {
  return parseInt(value.toString()) > 0;
}

export function firstDecimals(num: number, decimals: number): number {
  // Convert the number to a string
  const numStr = num.toString();

  // Find the position of the decimal point
  const decimalIndex = numStr.indexOf('.');

  if (decimalIndex !== -1) {
    // If the number is a decimal, proceed to truncate it
    // Calculate the index up to which we want to keep the string
    // We add 1 to account for the decimal point itself, and 6 for the decimal places
    const endIndex = decimalIndex + 1 + decimals;

    // Use substring to get the string up to the desired number of decimal places
    const truncatedStr = numStr.substring(0, Math.min(endIndex, numStr.length));

    // Convert the truncated string back to a number and return it
    return parseFloat(truncatedStr);
  } else {
    // If there's no decimal part, return the number as is
    return num;
  }
}

export const getSupportedTokens = (chainId: number) => {
  const supportedTokens = bridgeTokens.filter((token: BridgeToken) => {
    return token.address[chainId] !== undefined && token.enabled;
  });
  return supportedTokens;
};
